module.exports = __webpack_public_path__ + "static/media/Marotte_Noyer_Sepium_MT12-10-Scale.9e1656b3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/surfaces/variants/Marotte_Noyer_Sepium_MT12-10-Scale.jpg
// module id = 958
// module chunks = 37